import React from 'react';

import productOrigin from '../../../main/assets/images/wingcore/product-with-shadow.webp';

export const ProductOrigin = () => {
  return (
    <section className="wingcore-origin-section">
      <img
        src={productOrigin}
        alt="Closer look on the component with shadow effect"
        className="wingcore-origin-product"
      />
      <div className="wingcore-origin-content">
        <div className="wingcore-origin-text-first">
          <div className="wingcore-origin-text">
            <h2 className="wingcore-origin-title">100 % NDAA-COMPLIANT</h2>
            <p className="wingcore-origin-description">
              The first release from Orqa’s upcoming fixed-wing ecosystem is
              fully NDAA-compliant.
            </p>
          </div>
        </div>
        <div className="wingcore-origin-text-second">
          <div className="wingcore-origin-text">
            <h2 className="wingcore-origin-title">MADE IN EU</h2>
            <p className="wingcore-origin-description">
              Designed, manufactured, and assembled in Europe for complete
              supply chain sovereignty.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
